export default "__VITE_ASSET__D8Px2bmp__"